import { render, staticRenderFns } from "./detail-download.vue?vue&type=template&id=150c555a&scoped=true"
import script from "./detail-download.vue?vue&type=script&lang=js"
export * from "./detail-download.vue?vue&type=script&lang=js"
import style0 from "./detail-download.vue?vue&type=style&index=0&id=150c555a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150c555a",
  null
  
)

export default component.exports